module.exports = __webpack_public_path__ + "static/media/speech_16.bd3d25f2.svg";